import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { IoMdEye } from "react-icons/io";
import { RiPencilFill } from "react-icons/ri";
import PageHeader from '../../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../../Component/BasicComponents/BasicDataTable';
// import TerritoryAddAndEditModal from './components/TerritoryAddEditModal';
// import OnboardWindowModal from './components/OnboardWindowModal';
import RoundedDropdown from '../../../Component/BasicComponents/Dropdowns/RoundedDropdown';
import BeatAddAndEditModal from './components/BeatAddEditModal';
import { useBeatOutletsData } from './hooks/useBeat';



const BeatOutletMappingColumns = () => [
    {
        name: "Outlet Type",
        selector: (row: { Type: string|any }) => row.Type || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    {
        name: "Outlet Name",
        selector: (row: { OutletName: string }) => row.OutletName || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    {
        name: "Contact",
        selector: (row: { Contact: string|any }) => row.Contact || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    {
        name: "Classification",
        selector: (row: { Class: string }) => row.Class || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    {
        name: "VFq.",
        selector: (row: { VFq: string }) => row.VFq || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    {
        name: "Qualification",
        selector: (row: { Qualification: string }) => row.Qualification || '-',
        sortable: true,
         wrap: true,
        width: '180px',
    },
    // {
    //     name: "Enable",
    //     selector: (row: { Enabled: string|any }) => row.Enabled || '-',
    //     sortable: true,
    // },
]
const HeaderContent = (props: any) => {

    return (
        <div
            style={{
                marginBottom: "15px",
                display: "flex",
                justifyContent: "flex-end",
            }}
        >
            <RoundedDropdown
                options={[{ id: 1, label: 'test21' }, { id: 2, label: 'test2221' }]}
                onSelect={(e) => {
                    console.log(e)
                }}
                defaultLabel="All"
                width="auto"
                isShowHeading
                DropdownHeading="Org Unit"
                headingColor="#2e8dd3"
            />
        </div>
    );
};

const BeatOutletMapping = () => {
    const location = useLocation();
    const [paginationStates, setPaginationStates] = useState<any>({
        limit: 10,
        page: 1,
        search: null,
    });
    const { beatRowData } = location?.state || {};
    // console.log('beatRowData::', beatRowData)
    const {data,isLoading:isLoading} = useBeatOutletsData({
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
        },
        beatId:beatRowData?.BeatId
    })
 const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };
// console.log('data?.data',data?.data)
    return (
        <div
            className="p-4"
        >
            <PageHeader
                title={data?.data?.title||"Beat Outlet Mapping"}
                buttons={
                    [
                        // {
                        //     label: "Save",
                        //     onClick: () => { },
                        //     color: "#2e8dd3",
                        // },


                    ]}
            />
            <BasicDataTable
                 paginationTotalRows={data?.data?.total || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                
                handleSearch={(val: any) => { handleSearch(val) }}
                Title=""
                showSpinner={isLoading}
                columns={BeatOutletMappingColumns()}
                data={data?.data?.data || []}
            />
        </div>
    )
}

export default BeatOutletMapping
